import { render, staticRenderFns } from "./scs.vue?vue&type=template&id=14de89ca&scoped=true&"
import script from "./scs.vue?vue&type=script&lang=js&"
export * from "./scs.vue?vue&type=script&lang=js&"
import style0 from "./scs.vue?vue&type=style&index=0&id=14de89ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14de89ca",
  null
  
)

export default component.exports